
import { useSearchWizardStore, usePinia } from '#imports'
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { FacetCount } from '~/apps/facets/domain/FacetCounts'
import { HierarchyTree } from '../../../hierarchies/domain/types'

@Component({
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return {
      searchWizardStore,
    }
  },
})
export default class FilterAndSortLocation extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  @Prop()
    hierarchyPath: string

  @Prop({ required: true })
    facetCounts: FacetCount

  @Prop()
    isPriceSearch: boolean

  @Prop()
    hierarchyTree: HierarchyTree

  async selectHierarchy(node: HierarchyTree) {
    this.$emit('changed', node.path)
    this.$bubble('hierarchy', node.path)
    await this.$nextTick()
    this.scrollToHierarchy()
  }

  shouldShowLocation(path: string) {
    // always show locations above our current path regardless of counts
    if (this.hierarchyPath.startsWith(path)) {
      return true
    }
    // if not showing counts then show all
    if (!this.searchWizardStore.showCount) {
      return true
    }
    // if lower then show if we have a count
    return !!this.facetCounts[path] || path === '/'
  }

  scrollToHierarchy() {
    this.$puScrollTo('[data-filter-location-scroll-target]', {
      duration: 300,
      offset: 0,
    })
  }

  showCounts(path: string) {
    if (!this.searchWizardStore.showCount) {
      return false
    }
    // show counts below us
    return this.facetCounts[path] ? true : path.startsWith(this.hierarchyPath)
  }
}
